// 自定义列存储唯一索引
export default {
  // 广告概览
  AdvertGeneralView: 'AdvertGeneralView',
  // 广告管理
  AdvertCampaign: 'AdvertCampaign',
  // 广告组合
  AdvertCompose: 'AdvertCompose',
  // 广告投放(一级)
  AdvertThrowInFirst: 'AdvertThrowInFirst',
  // 广告组
  AdvertGroup: 'AdvertGroup',
  // 广告位
  AdvertSite: 'AdvertSite',
  // 广告
  Advert: 'Advert',
  // 广告-SB
  SBAdvert: 'SBAdvert',
  // 广告投放（三级）
  AdvertThrowIn: 'AdvertThrowIn',
  // 否定投放
  NThrowIn: 'NThrowIn',
  // 搜索词
  AdvertSearchWords: 'AdvertSearchWords',
  // 购买asin
  BuyAsinReport: 'BuyAsinReport',
  // 广告日志
  AdvertLog: 'AdvertLog',
  // 广告报表
  AdvertReport: 'AdvertReport',
  // 广告分析
  AdvertAnalyse: 'AdvertAnalyse',
  // PB广告-广告报表
  PBAdvert: 'PBAdvert',
  // PB广告-店铺报表
  PBAdvertShop: 'PBAdvertShop',
  // PB广告-商品报表
  PBAdvertGoods: 'PBAdvertGoods',
  // 关键词排名
  KeywordsRanking: 'KeywordsRanking',
  // 买家评价-review
  BuyerEvaluateReview: 'BuyerEvaluateReview',
  // 买家评价-OneToThreeStarFeedback
  BuyerEvaluateOneToThreeStarFeedback: 'BuyerEvaluateOneToThreeStarFeedback',
  // 买家评价-FourToFiveStarFeedback
  BuyerEvaluateFourToFiveStarFeedback: 'BuyerEvaluateFourToFiveStarFeedback',
  // 评价统计-review-asin
  evaluateTotalReviewAsin: 'evaluateTotalReviewAsin',
  // 评价统计-review-shop
  evaluateTotalReviewShop: 'evaluateTotalReviewShop',
  // 评价统计-feedback
  evaluateTotalFeedback: 'evaluateTotalFeedback',
  // 跟卖监控
  ToSellMonitor: 'ToSellMonitor',
  // 分时调价-创建模板
  CreateTemplate: 'CreateTemplate',
  ExecuteResult: 'ExecuteResult',
  // 自动规则
  AutoRule: 'AutoRule',
  // 应用详情
  UseDetails: 'UseDetails',
  // 商品表现
  ProductPerformanceAsin: 'ProductPerformanceAsin',
  ProductPerformanceMsku: 'ProductPerformanceMsku',
  ProductPerformanceParentAsin: 'ProductPerformanceParentAsin',
  // 店铺表现
  ShopPerformance: 'ShopPerformance',
  // 流量统计
  FlowPerformance: 'FlowPerformance',
  // 运营日志详情
  CalDetailsOverview: 'CalDetailsOverview',
  CalDetailsDetails: 'CalDetailsDetails',
  // 移除订单
  RemovalOrder: 'RemovalOrder',
  // FBA库龄
  FbaInventoryAged: 'FbaInventoryAged',
  // 长期仓储费
  LongTermWarehouseFee: 'LongTermWarehouseFee',
  // 月度仓储费
  MonthWarehouseFee: 'MonthWarehouseFee',
  // 退货订单
  ReturnsOrder: 'ReturnsOrder',
  // 回款记录 - 亚马逊
  CollectionVerificationAmazon: 'CollectionVerificationAmazon',
  // 利润报表 - 亚马逊
  ProfitStatementAmazonMsku: 'ProfitStatementAmazonMsku',
  ProfitStatementAmazonShopDetail: 'ProfitStatementAmazonShopDetail',
  ProfitStatementAmazonShopPandect: 'ProfitStatementAmazonShopPandect',
  ProfitStatementAmazonOrder: 'ProfitStatementAmazonOrder',
  ProfitStatementAmazonAsin: 'ProfitStatementAmazonAsin',
  // 利润报表 - 速卖通
  ProfitStatementAliexpressOrder: 'ProfitStatementAliexpressOrder',
  ProfitStatementAliexpressChildOrder: 'ProfitStatementAliexpressChildOrder',
  ProfitStatementAliexpressShop: 'ProfitStatementAliexpressShop',
  ProfitStatementAliexpressProduct: 'ProfitStatementAliexpressProduct',
  ProfitStatementAliexpressCountry: 'ProfitStatementAliexpressCountry',
  // 结算明细 - 拉赞大
  SettlementDetailsLazadaBriefOrder: 'SettlementDetailsLazadaBriefOrder',
  SettlementDetailsLazadaBriefChildOrder: 'SettlementDetailsLazadaBriefChildOrder',
  SettlementDetailsLazadaDetailOrder: 'SettlementDetailsLazadaDetailOrder',
  SettlementDetailsLazadaDetailChildOrder: 'SettlementDetailsLazadaDetailChildOrder',
  // 结算明细 - 虾皮
  SettlementDetailsShopeeOrder: 'SettlementDetailsShopeeOrder',
  SettlementDetailsShopeeChildOrder: 'SettlementDetailsShopeeChildOrder',
  pluginHelperTaskList: 'pluginHelperTaskList',
  // 结算明细 - 虾皮 new
  SettlementDetailsShopeeOrderIncomeOrder: 'SettlementDetailsShopeeOrderIncomeOrder',
  SettlementDetailsShopeeOrderIncomeChildOrder: 'SettlementDetailsShopeeOrderIncomeChildOrder',
  SettlementDetailsShopeeAdjustFeeOrder: 'SettlementDetailsShopeeAdjustFeeOrder',
  SettlementDetailsShopeeAdjustFeeChildOrder: 'SettlementDetailsShopeeAdjustFeeChildOrder',
  // 结算明细 - 速卖通
  SettlementDetailsAliexpressOrder: 'SettlementDetailsAliexpressOrder',
  SettlementDetailsAliexpressChildOrder: 'SettlementDetailsAliexpressChildOrder',
  // 结算明细 - Amazon
  SettlementDetailsAmazonMainTable: 'SettlementDetailsAmazonMainTable',
  // 订单列表-简版
  OrderListLite: 'OrderListLite',
  // 订单列表-精版
  OrderListDelux: 'OrderListDelux',
  // 利润报表 虾皮
  profitStatementShopeeOrderOrder: 'profitStatementShopeeOrderOrder',
  profitStatementShopeeOrderChildOrder: 'profitStatementShopeeOrderChildOrder',
  profitStatementShopeeSkuBrief: 'profitStatementShopeeSkuBrief',
  profitStatementShopeeSkuDetail: 'profitStatementShopeeSkuDetail',
  profitStatementShopeeShopBrief: 'profitStatementShopeeShopBrief',
  profitStatementShopeeShopDetail: 'profitStatementShopeeShopDetail',
  // 利润报表 lazada
  profitStatementLazadaOrder: 'profitStatementLazadaOrder',
  profitStatementLazadaChildOrder: 'profitStatementLazadaChildOrder',
  profitStatementLazadaSkuBrief: 'profitStatementLazadaSkuBrief',
  profitStatementLazadaSkuDetail: 'profitStatementLazadaSkuDetail',
  profitStatementLazadaShopBrief: 'profitStatementLazadaShopBrief',
  profitStatementLazadaShopDetail: 'profitStatementLazadaShopDetail',
  // 订单利润报表-订单
  orderProfitStatement: 'orderProfitStatement',
  // 订单利润报表-明细
  orderDetailProfitStatement: 'orderDetailProfitStatement',
  // 月结利润报表-订单
  monthlyProfitStatement: 'monthlyProfitStatement',
  // 月结利润报表-明细
  monthDetailProfitStatement: 'monthDetailProfitStatement',
  // 下载中心
  downloadCenterDefault: 'downloadCenterDefault',
  // 日加权平均价初始化
  weightedAveragePrice: 'weightedAveragePrice',
  // 日加权平均价 财务菜单里面的 列表
  weightedAveragePriceFinanceList: 'weightedAveragePriceFinanceList',
  // 先进先出
  fifo: 'fifo',
  // FBA进销存报表 - 数量
  FbaPurchaseSellStock: 'FbaPurchaseSellStock',
  // FBA进销存报表 - 成本
  FbaPurchaseSellStockCost: 'FbaPurchaseSellStockCost',
  // FBA进销存报表 - 成本-展开
  FbaPurchaseSellStockCostSpread: 'FbaPurchaseSellStockCostSpread',
  // 头程分摊
  FirstTripShare: 'FirstTripShare',
  // 应收明细
  // 应收明细 虾皮
  receivableDetailShopee: 'receivableDetailShopee',
  // 应收明细 lazada
  receivableDetailLazada: 'receivableDetailLazada',
  // 应收明细 aliexpress
  receivableDetailAliExpress: 'receivableDetailAliExpress',
  // 对账管理
  checkManageShopee: 'checkManageShopee',
  // 账户管理
  accountManagement: 'accountManagement',
  // 费用请款单
  requestForPayment: 'requestForPayment',
  // 收付款单
  receiptAndPayment: 'receiptAndPayment',
  // 换货订单
  ReplacementOrder: 'ReplacementOrder',
  // 补货建议 - asin
  ReplenishmentAdviceAsin: 'ReplenishmentAdviceAsin',
  // 补货建议 - msku
  ReplenishmentAdviceMsku: 'ReplenishmentAdviceMsku',
  ReplenishmentAdviceMsku3: 'ReplenishmentAdviceMsku3',
  // 销售统计-asin
  ImmediateSalesAsin: 'ImmediateSalesAsin',
  // 销售统计-父asin
  ImmediateSalesParentAsin: 'ImmediateSalesParentAsin',
  // 销售统计-msku
  ImmediateSalesMsku: 'ImmediateSalesMsku',
  // 销售统计-店铺
  ImmediateSalesShop: 'ImmediateSalesShop',
  // 销售统计-sku
  ImmediateSalesSku: 'ImmediateSalesSku',
  // 销售统计-品牌
  ImmediateSalesBrand: 'ImmediateSalesBrand',
  // 销售统计-分类
  ImmediateSalesClassify: 'ImmediateSalesClassify',
  // 销售统计-SPU
  ImmediateSalesSpu: 'ImmediateSalesSpu',
  // 全平台利润报表
  profitSettlementGlobalProfitDetailPlatform: 'profitSettlementGlobalProfitDetailPlatform',
  profitSettlementGlobalProfitDetailShop: 'profitSettlementGlobalProfitDetailShop',
  profitSettlementGlobalProfitReportMain: 'profitSettlementGlobalProfitReportMain',
  // 赔偿报告
  CompensationReport: 'CompensationReport',
  // 平台对账 仓储费 概览
  PLATFORM_CHECK_AMAZON_WAREHOUSE_CHARGES_BRIEF: 'PLATFORM_CHECK_AMAZON_WAREHOUSE_CHARGES_BRIEF',
  // 平台对账 仓储费 明细
  PLATFORM_CHECK_AMAZON_WAREHOUSE_CHARGES_PRODUCT_DETAIL: 'PLATFORM_CHECK_AMAZON_WAREHOUSE_CHARGES_PRODUCT_DETAIL',
  // 平台对账 LD费 概览
  PLATFORM_CHECK_AMAZON_LIGHTNING_DEAL_BRIEF: 'PLATFORM_CHECK_AMAZON_LIGHTNING_DEAL_BRIEF',
  // 平台对账 LD费 明细
  PLATFORM_CHECK_AMAZON_LIGHTNING_DEAL_PRODUCT_DETAIL: 'PLATFORM_CHECK_AMAZON_LIGHTNING_DEAL_PRODUCT_DETAIL',
  // 平台对账 移除弃置费 概览
  PLATFORM_CHECK_AMAZON_REMOVE_BRIEF: 'PLATFORM_CHECK_AMAZON_REMOVE_BRIEF',
  // 平台对账 移除弃置费 明细
  PLATFORM_CHECK_AMAZON_REMOVE_PRODUCT_DETAIL: 'PLATFORM_CHECK_AMAZON_REMOVE_PRODUCT_DETAIL',
  // 回款记录 shopee
  SettlementRecordsShopee: 'SettlementRecordsShopee',
  // 回款记录 shopee 本土店
  SettlementRecordsShopeeLocalShop: 'SettlementRecordsShopeeLocalShop',
  // 回款记录 lazada
  SettlementRecordsLazada: 'SettlementRecordsLazada',
  // 回款记录-异常账期
  abnormalPaymentDays: 'abnormalPaymentDays',
  // Listing管理
  OperationAdmin: 'OperationAdmin',
  // 费用管理
  feeMgtSystemSku: 'feeMgtSystemSku',
  feeMgtPlatformSku: 'feeMgtPlatformSku',
  feeMgtOrderNo: 'feeMgtOrderNo',
  feeMgtShop: 'feeMgtShop',
  feeMgtRuleConfig: 'feeMgtRuleConfig',
  // 秒杀 - 已报名
  SeckillRegistered: 'SeckillRegistered',
  // 秒杀 - 可报名
  SeckillSignUp: 'SeckillSignUp',
  // 店铺绩效
  ShopMerit: 'ShopMerit',
  // FBA补货设置 - 备货规则
  FbaReplenishmentStockUp: 'FbaReplenishmentStockUp',
  // FBA补货设置 - 测算日销
  FbaReplenishmentDailySales: 'FbaReplenishmentDailySales',
  // 进销存报表-速卖通-main
  purchaseSaleStockReportAliexpressMain: 'purchaseSaleStockReportMain',
  // 请求评论-请求规则
  RequestRule: 'RequestRule',
  // 请求评论-请求记录
  RequestRecord: 'RequestRecord',
  // FBA 库存
  fbaInventoryQuantity: 'fbaInventoryQuantity',
  fbaInventoryCost: 'fbaInventoryCost',
  // 速卖通批次成本
  AeBatchCost: 'AeBatchCost',
  // 速卖通扣减明细
  AeDeductionDetail: 'AeDeductionDetail',
  // wish
  profitSettlementWishOrder: 'profitSettlementWishOrder',
  // 销售利润-msku
  SalesProfitMsku: 'SalesProfitMsku',
  // listing分析 - 概览 - 日
  OperationAnalyseOverviewDay: 'OperationAnalyseOverviewDay',
  // listing分析 - 概览 - 周 - 环比
  OperationAnalyseOverviewWeekChain: 'OperationAnalyseOverviewWeekChain',
  // listing分析 - 概览 - 周 - 星期
  OperationAnalyseOverviewWeekDay: 'OperationAnalyseOverviewWeekDay',
  // listing分析 - 概览 - 月
  OperationAnalyseOverviewMonth: 'OperationAnalyseOverviewMonth',
  // 进销存明细
  purchaseSalesStockDetail: 'purchaseSalesStockDetail',
  // 头程对账
  FirstCarryCostCheck: 'FirstCarryCostCheck',
  // 物流账单-首公里
  LogisticsBillFirstKm: 'LogisticsBillFirstKm',
  // 物流账单-头程
  LogisticsBillFirstCarryCost: 'LogisticsBillFirstCarryCost',
  // 物流账单-尾程
  LogisticsBillTailCost: 'LogisticsBillTailCost',
  // 进销存统计
  purchaseSalesStockStatistics: 'purchaseSalesStockStatistics',
  // 成本调整单
  costAdjustmentBill: 'costAdjustmentBill',
  // 结账 checkout === 检验  check out === 结账
  checkOut: 'checkOut',
}
